import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="steps"
export default class extends Controller {

  static targets = ["step", "next", "prev", "submit"]

  static values = { index: Number }

  connect() {
    this.stepTargets.forEach((step, index) => {
      step.dataset.index = index;
    })

    let errors = this.element.querySelector('.field__errors');

    if (errors) {
      let step = errors.closest('.steps__step')

      this.indexValue = parseInt(step.dataset.index);
    }


    this.indexValueChanged();
  }

  next(e) {
    e.preventDefault();

    this.indexValue += 1;
  }

  prev(e) {
    e.preventDefault();

    this.indexValue -= 1;
  }

  indexValueChanged() {
    if (this.hasPrevTarget) {
      this.prevTarget.disabled = (this.indexValue == 0);
      this.submitTarget.disabled = (this.indexValue < this.stepTargets.length - 1);
      this.nextTarget.disabled = !this.submitTarget.disabled;
    }

    this.stepTargets.forEach((step, index) => {
      step.classList.toggle("steps__step--active", index === this.indexValue)
    })
  }
}
